<template functional>
	<div class="cus-pagination-wrapper">
		<div class="cus-pagination__left-part" v-if="data.attrs">
			<span v-if="data.attrs.sizes!=false">共 {{ data.attrs.total }} 个， </span>共 {{ Math.ceil(+data.attrs.total / +data.attrs['page-size']) }} 页，
            第 {{ data.attrs['current-page'] }} 页
		</div>
		<el-pagination
			v-on="listeners"
			v-bind="data.attrs"
			:layout="data.attrs.sizes==false?'prev, pager, next,jumper':'prev, pager, next, sizes,jumper'"
			:pager-count="5"
			:page-sizes="[10, 20, 30, 50]"
		>
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: 'cusPagination',
};
</script>

<style lang="scss">
.cus-pagination-wrapper {
	display: flex;
    .el-pagination {
        padding: 0;
        .btn-prev {
            margin-right: 8px;
        }
        &__jump{
            height: 34px;
            line-height: 34px;
            .el-input__inner{
                height: 34px;
                line-height: 34px;
            }
        }
        &>button {
            width: 34px;
            height: 34px;
            line-height: 32px;
            box-sizing: border-box;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            padding: 0;
            span {
                height: 34px;
                line-height: 34px;
                font-size: 12px;
            }
            &:disabled {
                background-color: #f7f7f7;
            }
        }
        .el-select .el-input {
            margin-right: 0;
        }
        .el-pagination__sizes {
            height: 34px;
            line-height: 34px;
            margin-right: 0;
        }
        .el-input--mini .el-input__inner {
            height: 34px;
            line-height: 34px;
        }
        .el-pagination__jump {
            .el-pagination__editor {
                height: 34px;
                line-height: 34px;
                .el-input__inner {
                    height: 34px;
                    line-height: 34px;
                    border-radius: 4px;
                }
            }
        }
        .el-pager {
            li {
                padding: 0;
                width: 34px;
                min-width: 34px;
                height: 34px;
                line-height: 32px;
                border-radius: 4px;
                box-sizing: border-box;
                border: 1px solid #dcdfe6;
                font-size: 12px;
                font-weight: normal;
                color: #161C26;
                margin-right: 8px;
                &:not([class*='active']):hover {
                    color: #409eff;
                }
            }
            .active {
                background: #002b9c;
                color: #FFFFFF;
            }
        }
    }
	.cus-pagination__left-part {
		flex: 1;
		height: 34px;
		font-size: 14px;
		font-weight: 400;
		color: #8998a0;
		line-height: 34px;
	}
}
</style>
